import axios from "axios";
import config from "app/api/axiosConfig";
import { IMaster } from "app/api/types/Masters";

export default (token: string, data: IMaster) =>
  axios.post(
    `${process.env.REACT_APP_API_HOST}/admin/masters`,
    data,
    config(token)
  );
